export default __webpack_public_path__ + "static/media/angular.9087b867.svg";